// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file deck/deck.proto (package lvdr.v2.deck, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AiMark } from "../common/aimark_pb";
import { file_common_aimark } from "../common/aimark_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file deck/deck.proto.
 */
export const file_deck_deck: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_aimark]);

/**
 * @generated from message lvdr.v2.deck.DeckIR
 */
export type DeckIR = Message<"lvdr.v2.deck.DeckIR"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string subtitle = 2;
   */
  subtitle: string;

  /**
   * explainer | business | education
   *
   * @generated from field: string style = 3;
   */
  style: string;

  /**
   * @generated from field: repeated lvdr.v2.deck.Slide slides = 4;
   */
  slides: Slide[];

  /**
   * @generated from field: repeated lvdr.v2.deck.Source sources = 5;
   */
  sources: Source[];

  /**
   * Per-deck identity override. Lives IN the IR, not beside it, so it travels
   * through export, share links and the GDPR bundle (design §3.1).
   *
   * @generated from field: lvdr.v2.deck.ThemeOverride theme = 6;
   */
  theme?: ThemeOverride | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckIR.
 * Use `create(DeckIRSchema)` to create a new message.
 */
export const DeckIRSchema: GenMessage<DeckIR> = /*@__PURE__*/
  messageDesc(file_deck_deck, 0);

/**
 * A per-deck theme override. `tokens` is keyed by the CLOSED vocabulary in
 * internal/deck/theme.go — an unknown key is rejected at write time, and the
 * derived tokens (fg, muted) are rejected outright because they are computed
 * from the resolved background rather than chosen (design §3.4).
 *
 * @generated from message lvdr.v2.deck.ThemeOverride
 */
export type ThemeOverride = Message<"lvdr.v2.deck.ThemeOverride"> & {
  /**
   * @generated from field: map<string, string> tokens = 1;
   */
  tokens: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.deck.ThemeOverride.
 * Use `create(ThemeOverrideSchema)` to create a new message.
 */
export const ThemeOverrideSchema: GenMessage<ThemeOverride> = /*@__PURE__*/
  messageDesc(file_deck_deck, 1);

/**
 * @generated from message lvdr.v2.deck.Slide
 */
export type Slide = Message<"lvdr.v2.deck.Slide"> & {
  /**
   * title|section|bullets|statement|two_col|stat|closing|cover|agenda
   *
   * @generated from field: string layout = 1;
   */
  layout: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: repeated lvdr.v2.deck.Block blocks = 3;
   */
  blocks: Block[];

  /**
   * @generated from field: repeated lvdr.v2.deck.Citation citations = 4;
   */
  citations: Citation[];

  /**
   * @generated from field: string speaker_notes = 5;
   */
  speakerNotes: string;

  /**
   * two_col only: ""|even|media-major|media-minor
   *
   * @generated from field: string split = 6;
   */
  split: string;
};

/**
 * Describes the message lvdr.v2.deck.Slide.
 * Use `create(SlideSchema)` to create a new message.
 */
export const SlideSchema: GenMessage<Slide> = /*@__PURE__*/
  messageDesc(file_deck_deck, 2);

/**
 * @generated from message lvdr.v2.deck.Block
 */
export type Block = Message<"lvdr.v2.deck.Block"> & {
  /**
   * bullet|text|stat|quote|image|diagram|timeline|table
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: repeated string items = 3;
   */
  items: string[];

  /**
   * @generated from field: string value = 4;
   */
  value: string;

  /**
   * @generated from field: string url = 5;
   */
  url: string;

  /**
   * trusted-only (kroki), never from LLM JSON
   *
   * @generated from field: string svg = 6;
   */
  svg: string;

  /**
   * quote only: who said it
   *
   * @generated from field: string attribution = 7;
   */
  attribution: string;

  /**
   * timeline only
   *
   * @generated from field: repeated lvdr.v2.deck.TimelineEntry entries = 8;
   */
  entries: TimelineEntry[];

  /**
   * table only. `rows` is row-major; when has_header is set rows[0] IS the
   * header — it is not a separate field, so a table cannot claim a header it
   * does not have. proto3 forbids a repeated-of-repeated, hence TableRow.
   *
   * @generated from field: repeated lvdr.v2.deck.TableRow rows = 9;
   */
  rows: TableRow[];

  /**
   * @generated from field: bool has_header = 10;
   */
  hasHeader: boolean;
};

/**
 * Describes the message lvdr.v2.deck.Block.
 * Use `create(BlockSchema)` to create a new message.
 */
export const BlockSchema: GenMessage<Block> = /*@__PURE__*/
  messageDesc(file_deck_deck, 3);

/**
 * @generated from message lvdr.v2.deck.TimelineEntry
 */
export type TimelineEntry = Message<"lvdr.v2.deck.TimelineEntry"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * free text ("Q3 2024", "1998–2003"); never parsed
   *
   * @generated from field: string date = 2;
   */
  date: string;

  /**
   * @generated from field: string text = 3;
   */
  text: string;
};

/**
 * Describes the message lvdr.v2.deck.TimelineEntry.
 * Use `create(TimelineEntrySchema)` to create a new message.
 */
export const TimelineEntrySchema: GenMessage<TimelineEntry> = /*@__PURE__*/
  messageDesc(file_deck_deck, 4);

/**
 * @generated from message lvdr.v2.deck.TableRow
 */
export type TableRow = Message<"lvdr.v2.deck.TableRow"> & {
  /**
   * @generated from field: repeated string cells = 1;
   */
  cells: string[];
};

/**
 * Describes the message lvdr.v2.deck.TableRow.
 * Use `create(TableRowSchema)` to create a new message.
 */
export const TableRowSchema: GenMessage<TableRow> = /*@__PURE__*/
  messageDesc(file_deck_deck, 5);

/**
 * @generated from message lvdr.v2.deck.Citation
 */
export type Citation = Message<"lvdr.v2.deck.Citation"> & {
  /**
   * 1-indexed ordinal into DeckIR.sources
   *
   * @generated from field: int32 ref = 1;
   */
  ref: number;

  /**
   * optional; must equal sources[ref-1].id when set
   *
   * @generated from field: string source_id = 2;
   */
  sourceId: string;

  /**
   * The verbatim run of words from sources[ref-1] that establishes this slide's
   * claim — the exhibit the deterministic grounding gate verifies. Capped at
   * 300 runes (deck.MaxSupportRunes). Must survive every round trip through
   * this wire: a conversion that drops it silently strips the deck's grounding.
   *
   * @generated from field: string support = 3;
   */
  support: string;
};

/**
 * Describes the message lvdr.v2.deck.Citation.
 * Use `create(CitationSchema)` to create a new message.
 */
export const CitationSchema: GenMessage<Citation> = /*@__PURE__*/
  messageDesc(file_deck_deck, 6);

/**
 * @generated from message lvdr.v2.deck.Source
 */
export type Source = Message<"lvdr.v2.deck.Source"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;
};

/**
 * Describes the message lvdr.v2.deck.Source.
 * Use `create(SourceSchema)` to create a new message.
 */
export const SourceSchema: GenMessage<Source> = /*@__PURE__*/
  messageDesc(file_deck_deck, 7);

/**
 * A persisted deck: the canonical IR wrapped with store metadata.
 *
 * resolved_theme is the SERVER'S resolution of system default → org brand kit →
 * per-deck override, fully resolved with no inheritance left to interpret. It
 * rides in this payload rather than being fetched separately for two reasons:
 * a second fetch would paint the editor unstyled first, and — more importantly —
 * it is what lets the frontend hold no palette of its own. The React canvas
 * spreads this exact map as CSS custom properties and the Go renderer emits the
 * same map as a :root{} block, so the two surfaces have no opinion that could
 * disagree. See internal/deck/theme.go; design §2.4.
 *
 * DeckSummary deliberately does NOT carry this: nothing renders from a summary
 * (DeckList.tsx is text-only, and SlideThumb takes the full deck), so adding it
 * there would ship the payload to no purpose.
 *
 * @generated from message lvdr.v2.deck.DeckDoc
 */
export type DeckDoc = Message<"lvdr.v2.deck.DeckDoc"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: lvdr.v2.deck.DeckIR ir = 2;
   */
  ir?: DeckIR | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: map<string, string> resolved_theme = 5;
   */
  resolvedTheme: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.deck.DeckDoc.
 * Use `create(DeckDocSchema)` to create a new message.
 */
export const DeckDocSchema: GenMessage<DeckDoc> = /*@__PURE__*/
  messageDesc(file_deck_deck, 8);

/**
 * @generated from message lvdr.v2.deck.DeckSummary
 */
export type DeckSummary = Message<"lvdr.v2.deck.DeckSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: int32 slide_count = 3;
   */
  slideCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckSummary.
 * Use `create(DeckSummarySchema)` to create a new message.
 */
export const DeckSummarySchema: GenMessage<DeckSummary> = /*@__PURE__*/
  messageDesc(file_deck_deck, 9);

/**
 * @generated from message lvdr.v2.deck.DeckEditOp
 */
export type DeckEditOp = Message<"lvdr.v2.deck.DeckEditOp"> & {
  /**
   * must match the payload arm; validated server-side
   *
   * @generated from field: string op = 1;
   */
  op: string;

  /**
   * @generated from oneof lvdr.v2.deck.DeckEditOp.payload
   */
  payload: {
    /**
     * @generated from field: lvdr.v2.deck.InsertSlideOp insert_slide = 2;
     */
    value: InsertSlideOp;
    case: "insertSlide";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeleteSlideOp delete_slide = 3;
     */
    value: DeleteSlideOp;
    case: "deleteSlide";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.MoveSlideOp move_slide = 4;
     */
    value: MoveSlideOp;
    case: "moveSlide";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.SetLayoutOp set_layout = 5;
     */
    value: SetLayoutOp;
    case: "setLayout";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.SetSplitOp set_split = 18;
     */
    value: SetSplitOp;
    case: "setSplit";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.SetDeckTitleOp set_deck_title = 6;
     */
    value: SetDeckTitleOp;
    case: "setDeckTitle";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.SetDeckSubtitleOp set_deck_subtitle = 7;
     */
    value: SetDeckSubtitleOp;
    case: "setDeckSubtitle";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.SetSlideTitleOp set_slide_title = 8;
     */
    value: SetSlideTitleOp;
    case: "setSlideTitle";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.InsertBlockOp insert_block = 9;
     */
    value: InsertBlockOp;
    case: "insertBlock";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeleteBlockOp delete_block = 10;
     */
    value: DeleteBlockOp;
    case: "deleteBlock";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.MoveBlockOp move_block = 11;
     */
    value: MoveBlockOp;
    case: "moveBlock";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.EditBlockOp edit_block = 12;
     */
    value: EditBlockOp;
    case: "editBlock";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.SetSpeakerNotesOp set_speaker_notes = 13;
     */
    value: SetSpeakerNotesOp;
    case: "setSpeakerNotes";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.SetCitationsOp set_citations = 14;
     */
    value: SetCitationsOp;
    case: "setCitations";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.AppendSourceOp append_source = 15;
     */
    value: AppendSourceOp;
    case: "appendSource";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.SetSourceOp set_source = 16;
     */
    value: SetSourceOp;
    case: "setSource";
  } | {
    /**
     * @generated from field: lvdr.v2.deck.DeleteSourceOp delete_source = 17;
     */
    value: DeleteSourceOp;
    case: "deleteSource";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message lvdr.v2.deck.DeckEditOp.
 * Use `create(DeckEditOpSchema)` to create a new message.
 */
export const DeckEditOpSchema: GenMessage<DeckEditOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 10);

/**
 * @generated from message lvdr.v2.deck.InsertSlideOp
 */
export type InsertSlideOp = Message<"lvdr.v2.deck.InsertSlideOp"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: lvdr.v2.deck.Slide slide = 2;
   */
  slide?: Slide | undefined;
};

/**
 * Describes the message lvdr.v2.deck.InsertSlideOp.
 * Use `create(InsertSlideOpSchema)` to create a new message.
 */
export const InsertSlideOpSchema: GenMessage<InsertSlideOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 11);

/**
 * @generated from message lvdr.v2.deck.DeleteSlideOp
 */
export type DeleteSlideOp = Message<"lvdr.v2.deck.DeleteSlideOp"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;
};

/**
 * Describes the message lvdr.v2.deck.DeleteSlideOp.
 * Use `create(DeleteSlideOpSchema)` to create a new message.
 */
export const DeleteSlideOpSchema: GenMessage<DeleteSlideOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 12);

/**
 * @generated from message lvdr.v2.deck.MoveSlideOp
 */
export type MoveSlideOp = Message<"lvdr.v2.deck.MoveSlideOp"> & {
  /**
   * @generated from field: int32 from = 1;
   */
  from: number;

  /**
   * @generated from field: int32 to = 2;
   */
  to: number;
};

/**
 * Describes the message lvdr.v2.deck.MoveSlideOp.
 * Use `create(MoveSlideOpSchema)` to create a new message.
 */
export const MoveSlideOpSchema: GenMessage<MoveSlideOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 13);

/**
 * @generated from message lvdr.v2.deck.SetLayoutOp
 */
export type SetLayoutOp = Message<"lvdr.v2.deck.SetLayoutOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: string layout = 2;
   */
  layout: string;
};

/**
 * Describes the message lvdr.v2.deck.SetLayoutOp.
 * Use `create(SetLayoutOpSchema)` to create a new message.
 */
export const SetLayoutOpSchema: GenMessage<SetLayoutOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 14);

/**
 * two_col column ratio: ""|even|media-major|media-minor. Its own op, not a
 * field on set_layout — a slide can change ratio without changing layout.
 *
 * @generated from message lvdr.v2.deck.SetSplitOp
 */
export type SetSplitOp = Message<"lvdr.v2.deck.SetSplitOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: string split = 2;
   */
  split: string;
};

/**
 * Describes the message lvdr.v2.deck.SetSplitOp.
 * Use `create(SetSplitOpSchema)` to create a new message.
 */
export const SetSplitOpSchema: GenMessage<SetSplitOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 15);

/**
 * @generated from message lvdr.v2.deck.SetDeckTitleOp
 */
export type SetDeckTitleOp = Message<"lvdr.v2.deck.SetDeckTitleOp"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message lvdr.v2.deck.SetDeckTitleOp.
 * Use `create(SetDeckTitleOpSchema)` to create a new message.
 */
export const SetDeckTitleOpSchema: GenMessage<SetDeckTitleOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 16);

/**
 * @generated from message lvdr.v2.deck.SetDeckSubtitleOp
 */
export type SetDeckSubtitleOp = Message<"lvdr.v2.deck.SetDeckSubtitleOp"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message lvdr.v2.deck.SetDeckSubtitleOp.
 * Use `create(SetDeckSubtitleOpSchema)` to create a new message.
 */
export const SetDeckSubtitleOpSchema: GenMessage<SetDeckSubtitleOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 17);

/**
 * `citations` on the two ops below is the UNDO channel for the exhibit, not an
 * authoring field. Forward, both ops replace claim text and the server clears
 * every Support on that slide (a span verified against the OLD words is not
 * evidence for the NEW ones — degenerate optimum #12). The inverse op must
 * therefore carry the spans it dropped, or undo restores the text and destroys
 * the exhibit permanently. The undo stack lives on the CLIENT, so the inverse
 * makes a full wire round trip and an in-memory-only field is dead on the only
 * path that exists — which is exactly what shipped until verify-goal caught it.
 *
 * @generated from message lvdr.v2.deck.SetSlideTitleOp
 */
export type SetSlideTitleOp = Message<"lvdr.v2.deck.SetSlideTitleOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: repeated lvdr.v2.deck.Citation citations = 3;
   */
  citations: Citation[];
};

/**
 * Describes the message lvdr.v2.deck.SetSlideTitleOp.
 * Use `create(SetSlideTitleOpSchema)` to create a new message.
 */
export const SetSlideTitleOpSchema: GenMessage<SetSlideTitleOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 18);

/**
 * @generated from message lvdr.v2.deck.InsertBlockOp
 */
export type InsertBlockOp = Message<"lvdr.v2.deck.InsertBlockOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: int32 index = 2;
   */
  index: number;

  /**
   * @generated from field: lvdr.v2.deck.Block block = 3;
   */
  block?: Block | undefined;
};

/**
 * Describes the message lvdr.v2.deck.InsertBlockOp.
 * Use `create(InsertBlockOpSchema)` to create a new message.
 */
export const InsertBlockOpSchema: GenMessage<InsertBlockOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 19);

/**
 * @generated from message lvdr.v2.deck.DeleteBlockOp
 */
export type DeleteBlockOp = Message<"lvdr.v2.deck.DeleteBlockOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: int32 index = 2;
   */
  index: number;
};

/**
 * Describes the message lvdr.v2.deck.DeleteBlockOp.
 * Use `create(DeleteBlockOpSchema)` to create a new message.
 */
export const DeleteBlockOpSchema: GenMessage<DeleteBlockOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 20);

/**
 * @generated from message lvdr.v2.deck.MoveBlockOp
 */
export type MoveBlockOp = Message<"lvdr.v2.deck.MoveBlockOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: int32 from = 2;
   */
  from: number;

  /**
   * @generated from field: int32 to = 3;
   */
  to: number;
};

/**
 * Describes the message lvdr.v2.deck.MoveBlockOp.
 * Use `create(MoveBlockOpSchema)` to create a new message.
 */
export const MoveBlockOpSchema: GenMessage<MoveBlockOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 21);

/**
 * @generated from message lvdr.v2.deck.EditBlockOp
 */
export type EditBlockOp = Message<"lvdr.v2.deck.EditBlockOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: int32 index = 2;
   */
  index: number;

  /**
   * @generated from field: lvdr.v2.deck.Block block = 3;
   */
  block?: Block | undefined;

  /**
   * @generated from field: repeated lvdr.v2.deck.Citation citations = 4;
   */
  citations: Citation[];
};

/**
 * Describes the message lvdr.v2.deck.EditBlockOp.
 * Use `create(EditBlockOpSchema)` to create a new message.
 */
export const EditBlockOpSchema: GenMessage<EditBlockOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 22);

/**
 * @generated from message lvdr.v2.deck.SetSpeakerNotesOp
 */
export type SetSpeakerNotesOp = Message<"lvdr.v2.deck.SetSpeakerNotesOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message lvdr.v2.deck.SetSpeakerNotesOp.
 * Use `create(SetSpeakerNotesOpSchema)` to create a new message.
 */
export const SetSpeakerNotesOpSchema: GenMessage<SetSpeakerNotesOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 23);

/**
 * @generated from message lvdr.v2.deck.SetCitationsOp
 */
export type SetCitationsOp = Message<"lvdr.v2.deck.SetCitationsOp"> & {
  /**
   * @generated from field: int32 slide = 1;
   */
  slide: number;

  /**
   * @generated from field: repeated lvdr.v2.deck.Citation citations = 2;
   */
  citations: Citation[];
};

/**
 * Describes the message lvdr.v2.deck.SetCitationsOp.
 * Use `create(SetCitationsOpSchema)` to create a new message.
 */
export const SetCitationsOpSchema: GenMessage<SetCitationsOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 24);

/**
 * @generated from message lvdr.v2.deck.AppendSourceOp
 */
export type AppendSourceOp = Message<"lvdr.v2.deck.AppendSourceOp"> & {
  /**
   * @generated from field: lvdr.v2.deck.Source source = 1;
   */
  source?: Source | undefined;
};

/**
 * Describes the message lvdr.v2.deck.AppendSourceOp.
 * Use `create(AppendSourceOpSchema)` to create a new message.
 */
export const AppendSourceOpSchema: GenMessage<AppendSourceOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 25);

/**
 * @generated from message lvdr.v2.deck.SetSourceOp
 */
export type SetSourceOp = Message<"lvdr.v2.deck.SetSourceOp"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: lvdr.v2.deck.Source source = 2;
   */
  source?: Source | undefined;
};

/**
 * Describes the message lvdr.v2.deck.SetSourceOp.
 * Use `create(SetSourceOpSchema)` to create a new message.
 */
export const SetSourceOpSchema: GenMessage<SetSourceOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 26);

/**
 * Safe delete: server rejects unless `index` is the LAST source AND it is
 * uncited — so it can never shift or dangle a Citation.Ref (plan B1). Exists
 * chiefly as append_source's inverse for undo.
 *
 * @generated from message lvdr.v2.deck.DeleteSourceOp
 */
export type DeleteSourceOp = Message<"lvdr.v2.deck.DeleteSourceOp"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;
};

/**
 * Describes the message lvdr.v2.deck.DeleteSourceOp.
 * Use `create(DeleteSourceOpSchema)` to create a new message.
 */
export const DeleteSourceOpSchema: GenMessage<DeleteSourceOp> = /*@__PURE__*/
  messageDesc(file_deck_deck, 27);

/**
 * @generated from message lvdr.v2.deck.DeckListRequest
 */
export type DeckListRequest = Message<"lvdr.v2.deck.DeckListRequest"> & {
};

/**
 * Describes the message lvdr.v2.deck.DeckListRequest.
 * Use `create(DeckListRequestSchema)` to create a new message.
 */
export const DeckListRequestSchema: GenMessage<DeckListRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 28);

/**
 * @generated from message lvdr.v2.deck.DeckListResponse
 */
export type DeckListResponse = Message<"lvdr.v2.deck.DeckListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.deck.DeckSummary decks = 1;
   */
  decks: DeckSummary[];
};

/**
 * Describes the message lvdr.v2.deck.DeckListResponse.
 * Use `create(DeckListResponseSchema)` to create a new message.
 */
export const DeckListResponseSchema: GenMessage<DeckListResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 29);

/**
 * DeckChangedEvent announces that one of the owner's decks changed, pushed
 * UNSOLICITED across instances by the realtime fan-out hub.
 *
 * It carries only an identity, never a DeckDoc, and that is deliberate. The deck
 * editor holds optimistic local state: apply-ops render immediately and are
 * reconciled against the server reply, with an undo/redo history layered on top.
 * Pushing a full document would race that state and could silently discard edits
 * the user has made but not yet round-tripped. An identity-only event lets the
 * client decide — refresh the list, or (for the deck it currently has open)
 * surface that a newer version exists rather than overwriting.
 *
 * deck_id empty means "the list changed" (a deck was created or deleted).
 *
 * @generated from message lvdr.v2.deck.DeckChangedEvent
 */
export type DeckChangedEvent = Message<"lvdr.v2.deck.DeckChangedEvent"> & {
  /**
   * "created" | "updated" | "deleted"
   *
   * @generated from field: string change_type = 1;
   */
  changeType: string;

  /**
   * @generated from field: string deck_id = 2;
   */
  deckId: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckChangedEvent.
 * Use `create(DeckChangedEventSchema)` to create a new message.
 */
export const DeckChangedEventSchema: GenMessage<DeckChangedEvent> = /*@__PURE__*/
  messageDesc(file_deck_deck, 30);

/**
 * @generated from message lvdr.v2.deck.DeckGetRequest
 */
export type DeckGetRequest = Message<"lvdr.v2.deck.DeckGetRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message lvdr.v2.deck.DeckGetRequest.
 * Use `create(DeckGetRequestSchema)` to create a new message.
 */
export const DeckGetRequestSchema: GenMessage<DeckGetRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 31);

/**
 * @generated from message lvdr.v2.deck.DeckGetResponse
 */
export type DeckGetResponse = Message<"lvdr.v2.deck.DeckGetResponse"> & {
  /**
   * @generated from field: lvdr.v2.deck.DeckDoc deck = 1;
   */
  deck?: DeckDoc | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckGetResponse.
 * Use `create(DeckGetResponseSchema)` to create a new message.
 */
export const DeckGetResponseSchema: GenMessage<DeckGetResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 32);

/**
 * Create from a supplied IR (e.g. a just-generated deck) or empty for a blank deck.
 *
 * @generated from message lvdr.v2.deck.DeckCreateRequest
 */
export type DeckCreateRequest = Message<"lvdr.v2.deck.DeckCreateRequest"> & {
  /**
   * @generated from field: lvdr.v2.deck.DeckIR ir = 1;
   */
  ir?: DeckIR | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckCreateRequest.
 * Use `create(DeckCreateRequestSchema)` to create a new message.
 */
export const DeckCreateRequestSchema: GenMessage<DeckCreateRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 33);

/**
 * @generated from message lvdr.v2.deck.DeckCreateResponse
 */
export type DeckCreateResponse = Message<"lvdr.v2.deck.DeckCreateResponse"> & {
  /**
   * @generated from field: lvdr.v2.deck.DeckDoc deck = 1;
   */
  deck?: DeckDoc | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckCreateResponse.
 * Use `create(DeckCreateResponseSchema)` to create a new message.
 */
export const DeckCreateResponseSchema: GenMessage<DeckCreateResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 34);

/**
 * @generated from message lvdr.v2.deck.DeckApplyOpsRequest
 */
export type DeckApplyOpsRequest = Message<"lvdr.v2.deck.DeckApplyOpsRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated lvdr.v2.deck.DeckEditOp ops = 2;
   */
  ops: DeckEditOp[];
};

/**
 * Describes the message lvdr.v2.deck.DeckApplyOpsRequest.
 * Use `create(DeckApplyOpsRequestSchema)` to create a new message.
 */
export const DeckApplyOpsRequestSchema: GenMessage<DeckApplyOpsRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 35);

/**
 * @generated from message lvdr.v2.deck.DeckApplyOpsResponse
 */
export type DeckApplyOpsResponse = Message<"lvdr.v2.deck.DeckApplyOpsResponse"> & {
  /**
   * @generated from field: lvdr.v2.deck.DeckDoc deck = 1;
   */
  deck?: DeckDoc | undefined;

  /**
   * @generated from field: repeated lvdr.v2.deck.DeckEditOp inverses = 2;
   */
  inverses: DeckEditOp[];
};

/**
 * Describes the message lvdr.v2.deck.DeckApplyOpsResponse.
 * Use `create(DeckApplyOpsResponseSchema)` to create a new message.
 */
export const DeckApplyOpsResponseSchema: GenMessage<DeckApplyOpsResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 36);

/**
 * @generated from message lvdr.v2.deck.DeckChatEditRequest
 */
export type DeckChatEditRequest = Message<"lvdr.v2.deck.DeckChatEditRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string instruction = 2;
   */
  instruction: string;

  /**
   * empty = whole-deck scope
   *
   * @generated from field: repeated int32 selected_slides = 3;
   */
  selectedSlides: number[];
};

/**
 * Describes the message lvdr.v2.deck.DeckChatEditRequest.
 * Use `create(DeckChatEditRequestSchema)` to create a new message.
 */
export const DeckChatEditRequestSchema: GenMessage<DeckChatEditRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 37);

/**
 * @generated from message lvdr.v2.deck.DeckChatEditResponse
 */
export type DeckChatEditResponse = Message<"lvdr.v2.deck.DeckChatEditResponse"> & {
  /**
   * @generated from field: lvdr.v2.deck.DeckDoc deck = 1;
   */
  deck?: DeckDoc | undefined;

  /**
   * what the model applied
   *
   * @generated from field: repeated lvdr.v2.deck.DeckEditOp ops = 2;
   */
  ops: DeckEditOp[];

  /**
   * for the client undo stack
   *
   * @generated from field: repeated lvdr.v2.deck.DeckEditOp inverses = 3;
   */
  inverses: DeckEditOp[];

  /**
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 4;
   */
  aiMark?: AiMark | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckChatEditResponse.
 * Use `create(DeckChatEditResponseSchema)` to create a new message.
 */
export const DeckChatEditResponseSchema: GenMessage<DeckChatEditResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 38);

/**
 * Re-render a diagram block's spec to trusted SVG (kroki) and write it into the block.
 *
 * @generated from message lvdr.v2.deck.DeckRenderDiagramRequest
 */
export type DeckRenderDiagramRequest = Message<"lvdr.v2.deck.DeckRenderDiagramRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 slide = 2;
   */
  slide: number;

  /**
   * @generated from field: int32 block = 3;
   */
  block: number;

  /**
   * @generated from field: string spec = 4;
   */
  spec: string;

  /**
   * mermaid|d2|graphviz|... (default mermaid)
   *
   * @generated from field: string dialect = 5;
   */
  dialect: string;
};

/**
 * Describes the message lvdr.v2.deck.DeckRenderDiagramRequest.
 * Use `create(DeckRenderDiagramRequestSchema)` to create a new message.
 */
export const DeckRenderDiagramRequestSchema: GenMessage<DeckRenderDiagramRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 39);

/**
 * @generated from message lvdr.v2.deck.DeckRenderDiagramResponse
 */
export type DeckRenderDiagramResponse = Message<"lvdr.v2.deck.DeckRenderDiagramResponse"> & {
  /**
   * @generated from field: string svg = 1;
   */
  svg: string;
};

/**
 * Describes the message lvdr.v2.deck.DeckRenderDiagramResponse.
 * Use `create(DeckRenderDiagramResponseSchema)` to create a new message.
 */
export const DeckRenderDiagramResponseSchema: GenMessage<DeckRenderDiagramResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 40);

/**
 * Generate a slide image with the AI image pipeline (paperbanana/Gemini), run it
 * through the same hygiene + DEK-sealing path an upload takes, and return the
 * stored asset's our-origin URL. The caller sets that URL on an image Block via
 * an edit_block op — image BYTES never ride the wire in either direction.
 *
 * This is a WS RPC, not an HTTP route, for one concrete reason: generation is
 * bounded at 90s (internal/deck.deckImageGenTimeout) while the Fiber server's
 * write_timeout defaults to 30s, so a synchronous HTTP response would be dropped
 * mid-flight on a slow generation — after the credits were already spent. The WS
 * surface has no such deadline, and chat-edit already carries a long model call
 * over it.
 *
 * @generated from message lvdr.v2.deck.DeckGenerateImageRequest
 */
export type DeckGenerateImageRequest = Message<"lvdr.v2.deck.DeckGenerateImageRequest"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * optional style hint (e.g. "flat vector, muted palette")
   *
   * @generated from field: string style = 2;
   */
  style: string;
};

/**
 * Describes the message lvdr.v2.deck.DeckGenerateImageRequest.
 * Use `create(DeckGenerateImageRequestSchema)` to create a new message.
 */
export const DeckGenerateImageRequestSchema: GenMessage<DeckGenerateImageRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 41);

/**
 * @generated from message lvdr.v2.deck.DeckGenerateImageResponse
 */
export type DeckGenerateImageResponse = Message<"lvdr.v2.deck.DeckGenerateImageResponse"> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * /api/v1/decks/assets/<id>
   *
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message lvdr.v2.deck.DeckGenerateImageResponse.
 * Use `create(DeckGenerateImageResponseSchema)` to create a new message.
 */
export const DeckGenerateImageResponseSchema: GenMessage<DeckGenerateImageResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 42);

/**
 * @generated from message lvdr.v2.deck.DeckExportPptxRequest
 */
export type DeckExportPptxRequest = Message<"lvdr.v2.deck.DeckExportPptxRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message lvdr.v2.deck.DeckExportPptxRequest.
 * Use `create(DeckExportPptxRequestSchema)` to create a new message.
 */
export const DeckExportPptxRequestSchema: GenMessage<DeckExportPptxRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 43);

/**
 * @generated from message lvdr.v2.deck.DeckExportPptxResponse
 */
export type DeckExportPptxResponse = Message<"lvdr.v2.deck.DeckExportPptxResponse"> & {
  /**
   * @generated from field: bytes artifact = 1;
   */
  artifact: Uint8Array;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 4;
   */
  aiMark?: AiMark | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckExportPptxResponse.
 * Use `create(DeckExportPptxResponseSchema)` to create a new message.
 */
export const DeckExportPptxResponseSchema: GenMessage<DeckExportPptxResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 44);

/**
 * PDF export renders the deck's own HTML through the export-worker's chromium
 * print path (render_pdf), NOT a PPTX->PDF conversion: the PDF is a print of the
 * same RenderHTML the editor and share links show, so it tracks the real look
 * and survives a renderer swap. Session-locked — slide images are DEK-sealed and
 * must be inlined backend-side before the HTML reaches the worker.
 *
 * @generated from message lvdr.v2.deck.DeckExportPdfRequest
 */
export type DeckExportPdfRequest = Message<"lvdr.v2.deck.DeckExportPdfRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message lvdr.v2.deck.DeckExportPdfRequest.
 * Use `create(DeckExportPdfRequestSchema)` to create a new message.
 */
export const DeckExportPdfRequestSchema: GenMessage<DeckExportPdfRequest> = /*@__PURE__*/
  messageDesc(file_deck_deck, 45);

/**
 * @generated from message lvdr.v2.deck.DeckExportPdfResponse
 */
export type DeckExportPdfResponse = Message<"lvdr.v2.deck.DeckExportPdfResponse"> & {
  /**
   * @generated from field: bytes artifact = 1;
   */
  artifact: Uint8Array;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 4;
   */
  aiMark?: AiMark | undefined;
};

/**
 * Describes the message lvdr.v2.deck.DeckExportPdfResponse.
 * Use `create(DeckExportPdfResponseSchema)` to create a new message.
 */
export const DeckExportPdfResponseSchema: GenMessage<DeckExportPdfResponse> = /*@__PURE__*/
  messageDesc(file_deck_deck, 46);

